<ui-spinner
  [diameter]="diameter"
  [spinnerButton]="spinnerButton"
  [color]="color"
  [mode]="mode"
  [value]="value"
>
  <div slot="image">
    <img class="img" src="../../../../../assets/logotipe/CLINNG.svg" alt="" />
  </div>
</ui-spinner>
